import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';
import {
  RestaurantPrinterConnectionType,
  RestaurantPrinterType,
} from '../../../../types/restaurant/RestaurantPrinterTypes';

export type PrinterStatusFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface PrinterFiltersProps {
  search: string;
  status: PrinterStatusFilter;
  printerType: RestaurantPrinterType | 'ALL';
  connectionType: RestaurantPrinterConnectionType | 'ALL';
  enabled: 'ALL' | 'ENABLED' | 'DISABLED';
  onSearchChange: (value: string) => void;
  onStatusChange: (value: PrinterStatusFilter) => void;
  onPrinterTypeChange: (value: RestaurantPrinterType | 'ALL') => void;
  onConnectionTypeChange: (value: RestaurantPrinterConnectionType | 'ALL') => void;
  onEnabledChange: (value: 'ALL' | 'ENABLED' | 'DISABLED') => void;
}

const PrinterFilters = ({
  search,
  status,
  printerType,
  connectionType,
  enabled,
  onSearchChange,
  onStatusChange,
  onPrinterTypeChange,
  onConnectionTypeChange,
  onEnabledChange,
}: PrinterFiltersProps) => (
  <div className="grid gap-4 border-b border-stroke px-5 py-4 dark:border-strokedark md:grid-cols-2 xl:grid-cols-5 xl:items-end">
    <div className="xl:pb-5">
      <SearchInputField
        label="Buscar"
        name="printerSearch"
        value={search}
        iconKey="search"
        placeholder="Nombre, equipo o dirección IP..."
        withMargin={false}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>
    <SelectField
      label="Estado"
      name="printerStatus"
      value={status}
      options={[
        { value: 'ALL', label: 'Todas' },
        { value: 'ACTIVE', label: 'Activas' },
        { value: 'INACTIVE', label: 'Inactivas' },
      ]}
      onChange={(event) => onStatusChange(event.target.value as PrinterStatusFilter)}
    />
    <SelectField
      label="Tipo"
      name="printerTypeFilter"
      value={printerType}
      options={[
        { value: 'ALL', label: 'Todos los tipos' },
        { value: 'RECEIPT', label: 'Recibos' },
        { value: 'LABEL', label: 'Etiquetas' },
        { value: 'KITCHEN', label: 'Cocina' },
      ]}
      onChange={(event) => onPrinterTypeChange(event.target.value as RestaurantPrinterType | 'ALL')}
    />
    <SelectField
      label="Conexión"
      name="printerConnectionFilter"
      value={connectionType}
      options={[
        { value: 'ALL', label: 'Todas las conexiones' },
        { value: 'LOCAL', label: 'Local' },
        { value: 'NETWORK', label: 'Red' },
      ]}
      onChange={(event) => onConnectionTypeChange(event.target.value as RestaurantPrinterConnectionType | 'ALL')}
    />
    <SelectField
      label="Disponibilidad"
      name="printerEnabledFilter"
      value={enabled}
      options={[
        { value: 'ALL', label: 'Todas' },
        { value: 'ENABLED', label: 'Habilitadas' },
        { value: 'DISABLED', label: 'Deshabilitadas' },
      ]}
      onChange={(event) => onEnabledChange(event.target.value as 'ALL' | 'ENABLED' | 'DISABLED')}
    />
  </div>
);

export default PrinterFilters;
